





















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Global } from '@/store';

@Component({})
class TableCellChips extends Vue {
  @Global.State('lang') lang;

  /** Each item needs an `id` to link to and a `name` to show. */
  @Prop({ type: Array, default: () => [] }) items;
  /** Route the item id is appended to, e.g. '/groups/'. */
  @Prop({ type: String, required: true }) route;
  @Prop({ type: String, default: '' }) empty_text;
  @Prop({ type: Number, default: 2 }) visible_count;
  /** Items that cannot be resolved yet are simply absent, so an empty list is ambiguous. */
  @Prop({ type: Boolean, default: false }) loading;

  get is_rtl() {
    return this.lang !== 'en';
  }

  get visible_items() {
    return this.items.slice(0, this.visible_count);
  }

  get hidden_items() {
    return this.items.slice(this.visible_count);
  }

  goToItem(item) {
    this.$router.push(`${this.route}${item.id}`);
  }
}

export default TableCellChips;
